import React, { useState } from 'react'
import toast from 'react-hot-toast';

const EditAddressModal = ({ open, onClose, onSave, registerAccount }) => {
    const [data, setData] = useState({...registerAccount});
    if (!open) return null;
    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    }

    const handleTextChange = (e) => {
        const { name, value } = e.target;
        setData((prev) => ({ ...prev, [name]: value }));
    };

    const validation = () => {
        if (!data?.country.trim()) {
            toast.error('Enter country.');
            return true;
        } else if (!data?.cep.trim()) {
            toast.error('Enter ZIP code.');
            return true;
        } else if (!data?.street.trim()) {
            toast.error('Enter street.');
            return true;
        } else if (!data?.number.trim()) {
            toast.error('Enter number.');
            return true;
        } else if (!data?.complement.trim()) {
            toast.error('Enter complement.');
            return true;
        } else if (!data?.neighborhood.trim()) {
            toast.error('Enter neighborhood.');
            return true;
        } else if (!data?.state.trim()) {
            toast.error('Enter state.');
            return true;
        } else if (!data?.city.trim()) {
            toast.error('Enter city.');
            return true;
        }
        return false;
    }

    const handleSubmit = () => {
        if (validation()) {
            return;
        }
        onSave(data);
    }

    const handleOnClose = () => {
        // setData(null);
        onClose();
    }

    return (
        <div className="edit-address-overlay" role="dialog" aria-modal="true">
            <div className="edit-address-modal">
                <div className="edit-address-title">Edit Address</div>

                <form className="edit-address-form" noValidate>
                    <div className="form-field form-control">
                        <label>Country</label>
                        <input
                            type="text"
                            name="country"
                            aria-label="Country"
                            aria-describedby="Country"
                            className="input-dark"
                            placeholder="Country"
                            value={data?.country}
                            onChange={handleTextChange}
                        />
                    </div>

                    <div className="form-field form-control">
                        <label>ZIP Code</label>
                        <input
                            type="text"
                            aria-label="cep"
                            aria-describedby="cep"
                            name="cep"
                            className="input-dark"
                            placeholder="ZIP Code"
                            value={data?.cep}
                            onChange={handleTextChange}
                        />
                    </div>

                    <div className="form-field form-control">
                        <label>Street</label>
                        <input
                            type="text"
                            name="street"
                            aria-label="Street"
                            aria-describedby="Street"
                            className="input-dark"
                            placeholder="Street"
                            value={data?.street}
                            onChange={handleTextChange}
                        />
                    </div>

                    <div className="form-field form-control">
                        <label>Number</label>
                        <input
                            type="text"
                            aria-label="Number"
                            aria-describedby="Number"
                            name="number"
                            className="input-dark"
                            placeholder="Number"
                            value={data?.number}
                            onChange={handleTextChange}
                        />
                    </div>

                    <div className="form-field form-control">
                        <label>Complement</label>
                        <input
                            type="text"
                            aria-label="Complement"
                            aria-describedby="Complement"
                            name="complement"
                            className="input-dark"
                            placeholder="Complement"
                            value={data?.complement}
                            onChange={handleTextChange}
                        />
                    </div>

                    <div className="form-field form-control">
                        <label>Neighborhood</label>
                        <input
                            type="text"
                            aria-label="Neighborhood"
                            aria-describedby="Neighborhood"
                            name="neighborhood"
                            className="input-dark"
                            placeholder="Neighborhood"
                            value={data?.neighborhood}
                            onChange={handleTextChange}
                        />
                    </div>

                    <div className="form-field form-control">
                        <label>State</label>
                        <input
                            type="text"
                            name="state"
                            aria-label="State"
                            aria-describedby="State"
                            className="input-dark"
                            placeholder="State"
                            value={data?.state}
                            onChange={handleTextChange}
                        />
                    </div>

                    <div className="form-field form-control">
                        <label>City</label>
                        <input
                            type="text"
                            aria-label="City"
                            aria-describedby="City"
                            name="city"
                            className="input-dark"
                            placeholder="City"
                            value={data?.city}
                            onChange={handleTextChange}
                        />
                    </div>
                </form>
                <div className="modal-actions">
                    <button
                        type="submit"
                        className="cursor-pointer btn-outer border-0 " onClick={handleOnClose}
                    >
                        <span className="btn-inner">Close</span>
                    </button>
                    <button
                        className="cursor-pointer btn-outer border-0 "
                        onClick={handleSubmit}
                    >
                        <span className="btn-inner bg-blue">Save</span>
                    </button>

                </div>
            </div>
        </div>
    )
}

export default EditAddressModal